'use strict';/* global define */define('modules/time/services/date-time-wrapper/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
       factory.$inject = ["moment"];
function factory(moment){return{/**
       * @param {Date|String} date
       * @param {String} format
       * @returns {String}
       */formatDate:function formatDate(date,format){return moment(date).format(format);},/**
       * @param {Date|String} date
       * @returns {String}
       */convertDateForSaving:function convertDateForSaving(date){return moment(date).utc().format();},/**
       * @param {String} dateString
       * @returns {Date}
       */convertDateString:function convertDateString(dateString){return moment.utc(dateString).toDate();},/**
       * @param  {String} date - date string
       * @param  {String} time - time string
       * @return {Date}
       */assembleDate:function assembleDate(date,time){return moment(date+'T'+time).utc().format();},/**
       * @returns {Date}
       */getToday:function getToday(){return moment().startOf('day').toDate();},/**
       * @returns {Date}
       */getEndOfToday:function getEndOfToday(){return moment().endOf('day').second(0).millisecond(0).toDate();},/**
       * @param {Date|String} date
       * @returns {Boolean}
       */isValidDate:function isValidDate(date){return moment(date).isValid();},/**
       * Get hours and minutes from a date string
       *
       * @param  {String} date - Date string
       * @returns {String}     - Hours and minutes e.g 15:00
       */getHoursAndMinutes:function getHoursAndMinutes(date){return moment(date).format('HH:mm');},/**
       * Check if the provided time string is properly formatted
       *
       * @param  {String} timeString - Time string e.g. 10:56
       * @returns {Boolean}          - Result of the operation
       */isValidTimeString:function isValidTimeString(timeString){return (/^(([0-1])([0-9]){1}|2([0-3]){1}):(([0-5])([0-9]){1})$/.test(timeString));},/**
       * @returns {String|Undefined}
       */getBrowserTimezone:function getBrowserTimezone(){return moment.tz.guess(true);},getTimezoneOffset:function getTimezoneOffset(){return moment().utcOffset();}};}module.exports=factory;});
